import { render, staticRenderFns } from "./UserIntegralDetail.vue?vue&type=template&id=052a593c&scoped=true&"
import script from "./UserIntegralDetail.vue?vue&type=script&lang=js&"
export * from "./UserIntegralDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserIntegralDetail.vue?vue&type=style&index=0&id=052a593c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a593c",
  null
  
)

export default component.exports